import { createDomain } from 'effector';

import { type DocumentStatusType } from 'types/zod/document-status-type';

const domain = createDomain('pages/validation');

const $$validation = {
    $guid: domain.createStore<string | null>(null),
    $isAuthorized: domain.createStore<boolean>(false),
    $loading: domain.createStore<boolean>(false),
    $document: domain.createStore<{ name: string; status: DocumentStatusType } | null>(null),
    $validationResult: domain.createStore<'success' | 'invalid' | 'error' | null>(null),
};

export default $$validation;
